import { useDispatch } from 'react-redux'

import { showModalCard } from '../../redux/slices/modalCard.js'


const ItemCard = (props) => {

    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(showModalCard({ show: true, data: { ...props } }))
    }

    return (
        <div className="fl-cl itemCard__container" id={props._id}>
            <div className="itemCard__div">
                <img className="itemCard__img" src={props.img} alt={props.title} />
            </div>
            <div className="itemCard__divShadow" />
            <button className="itemCard__button" onClick={handleClick}>ver más...</button>
        </div>
    )

}

export default ItemCard